'use strict';

const treeItemErrorClassName = `TreeItem-error-${Math.floor(Math.random() * 10000)}`;

exports.treeItemErrorClassName = treeItemErrorClassName;
//# sourceMappingURL=helpers.js.map
